/**
 * Act-as ("simulation") sessions that carry a personal admin's limits: no
 * password, email, payment or membership changes, no deleting the account, and
 * never the member's notes. Personal admins (RM-150), spouses (RM-159) and,
 * since RM-319, group admins. Only an RM (platform) admin's session is
 * unrestricted.
 *
 * The client's copy of RESTRICTED_SIMULATION_SCOPES in lib/permissions/roles.js,
 * which the server enforces; the client uses it only to hide the controls that
 * would be refused. Keep the two lists the same.
 */
export const RESTRICTED_SIMULATION_SCOPES = Object.freeze(['personal-admin', 'spouse', 'group-admin', 'self'])

/**
 * @param {string|null} scope - localStorage.simulationScope for this session
 * @returns {boolean}
 */
export function isRestrictedSimulationScope(scope) {
  return RESTRICTED_SIMULATION_SCOPES.includes(scope)
}

/**
 * RM-337 item 5 (was RM-339): whether this browser is in an act-as session with
 * a personal admin's limits. Controls that start another act-as session are
 * hidden then: the server refuses them.
 *
 * @param {Storage} [storage] - localStorage by default
 * @returns {boolean}
 */
export function inRestrictedSimulation(storage = (typeof localStorage === 'undefined' ? null : localStorage)) {
  if (!storage) return false

  return !!storage.getItem('simulation') && isRestrictedSimulationScope(storage.getItem('simulationScope'))
}

/**
 * The server's reason an act-as start was refused (POST /auth/login/simulation
 * answers { errors: { email: [message] } }), to show the person who tried.
 *
 * @param {Error} error - the axios error
 * @returns {string}
 */
export function actAsErrorMessage(error) {
  const data = error && error.response && error.response.data
  const fromErrors = data && data.errors && Array.isArray(data.errors.email) ? data.errors.email.find(Boolean) : null

  return fromErrors || (data && typeof data.error === 'string' && data.error) || 'Could not open that account.'
}
